/* Complete the look (PDP redesign, 2026).
   1. Quick add for one-variant pieces: POST /cart/add.js, then refresh the bag count (and the
      closed bag drawer's contents, without opening it).
   2. Level 3 fallback: when a product has no saved looks, ask Shopify for complementary
      products (same endpoint the theme's own "Complete the look" block uses) and show them.
   3. GA4 events (gtag, falling back to the dataLayer): view_item_list, select_item, add_to_cart,
      all with item_list_name "Complete the look" so the module can be reported on its own.
   Every part is defensive: if anything fails, the module simply does nothing or stays hidden. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('.pdp-look');
  if (!roots.length) return;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 0. Analytics (GA4) ---------- */
  var LIST_NAME = 'Complete the look';
  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  }
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: name, ecommerce: params });
      }
    } catch (err) { /* analytics must never break the page */ }
  }
  function listId(li) {
    var set = li.closest('.pdp-look__set');
    return 'complete_the_look_' + ((set && set.getAttribute('data-source')) || 'shopify');
  }
  function itemOf(li, index) {
    return {
      item_id: li.getAttribute('data-item-id'),
      item_name: li.getAttribute('data-item-name'),
      item_brand: li.getAttribute('data-item-brand') || undefined,
      price: Number(li.getAttribute('data-price')) || 0,
      quantity: 1,
      index: index,
      item_list_id: listId(li),
      item_list_name: LIST_NAME
    };
  }
  function trackSetViews(root) {
    var sets = root.querySelectorAll('.pdp-look__set');
    sets.forEach(function (set) {
      if (set.getAttribute('data-viewed')) return;
      var lis = set.querySelectorAll('.pdp-look__item:not(.pdp-look__item--photo)');
      if (!lis.length) return;
      set.setAttribute('data-viewed', '1');
      var items = [];
      lis.forEach(function (li, i) { items.push(itemOf(li, i)); });
      track('view_item_list', {
        item_list_id: items[0].item_list_id, item_list_name: LIST_NAME, items: items
      });
    });
  }
  function watchViews(root) {
    if (!('IntersectionObserver' in window)) { trackSetViews(root); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      trackSetViews(root);
    }, { threshold: 0.4 });
    io.observe(root);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pdp-look__img, .pdp-look__name, .pdp-look__choose');
    if (!a) return;
    var li = a.closest('.pdp-look__item');
    if (!li) return;
    var index = Array.prototype.indexOf.call(li.parentNode.children, li);
    track('select_item', {
      item_list_id: listId(li), item_list_name: LIST_NAME, items: [itemOf(li, index)], transport_type: 'beacon'
    });
  });

  /* ---------- 1. Quick add ---------- */
  function setStatus(root, html, isError) {
    var s = root.querySelector('.pdp-look__status');
    if (!s) return;
    s.classList.toggle('is-error', !!isError);
    s.innerHTML = html;
  }
  function updateBagCount() {
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('pdp-look:cart-updated', { detail: cart }));
        return cart;
      });
  }
  /* Keep the (closed) bag drawer in step, without opening it. Mirrors what the theme's own
     add-to-bag does, minus the "open" step. */
  function refreshDrawer(html) {
    try {
      var drawer = document.querySelector('cart-drawer');
      var dst = document.getElementById('CartDrawer');
      if (!drawer || !dst || !html) return;
      var src = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
      if (!src) return;
      dst.innerHTML = src.innerHTML;
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      var ov = drawer.querySelector('#CartDrawer-Overlay');
      if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
    } catch (err) { /* the drawer will refresh itself the next time the theme touches the cart */ }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pdp-look__add');
    if (!btn || btn.disabled) return;
    var root = btn.closest('.pdp-look');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: 'cart-drawer' })
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'error');
        refreshDrawer(res.body.sections && res.body.sections['cart-drawer']);
        return updateBagCount();
      })
      .then(function (cart) {
        var li = btn.closest('.pdp-look__item');
        if (li) {
          var it = itemOf(li, 0);
          it.item_variant = btn.dataset.variant;
          track('add_to_cart', { currency: currency(), value: it.price, items: [it] });
        }
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        var n = cart.item_count;
        setStatus(root, 'Added to your bag. <a href="' + base + 'cart">View bag (' + n + ')</a>', false);
        setTimeout(function () {
          btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = label;
        }, 2600);
      })
      .catch(function (err) {
        btn.textContent = 'Unavailable';
        btn.classList.add('is-error');
        setStatus(root, (btn.dataset.title || 'That piece') + ' could not be added: ' + (err.message || 'please try again') + '.', true);
        setTimeout(function () {
          btn.disabled = false; btn.classList.remove('is-error'); btn.textContent = label;
        }, 3200);
      });
  });

  /* ---------- 2. Fallback: Shopify complementary products ---------- */
  function loadFallback(el) {
    var host = el.closest('[data-section-id]');
    var sid = host && host.getAttribute('data-section-id');
    if (!sid || !el.dataset.recs || !el.dataset.product) return;
    var url = el.dataset.recs + '?section_id=' + encodeURIComponent(sid) +
      '&product_id=' + encodeURIComponent(el.dataset.product) + '&limit=8&intent=complementary';
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var items = doc.querySelectorAll('.pdp-look__fallback .pdp-look__item');
        if (items.length < 2) return;
        var row = el.querySelector('.pdp-look__row');
        for (var i = 0; i < items.length && i < 4; i++) row.appendChild(document.importNode(items[i], true));
        el.classList.remove('pdp-look--pending');
        watchViews(el);
      })
      .catch(function () { /* stay hidden */ });
  }
  roots.forEach(function (el) {
    if (!el.hasAttribute('data-fallback')) { watchViews(el); return; }
    if (!('IntersectionObserver' in window)) { loadFallback(el); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      loadFallback(el);
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(el);
  });
})();
